module.exports = __webpack_public_path__ + "img/file-markdown.dfbecea9.svg";